import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

// src/theme/ThemeProvider.tsx
var ThemeContext = React.createContext(null);
function useTheme() {
  const ctx = React.useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside <ThemeProvider>");
  return ctx;
}
function useOptionalTheme() {
  return React.useContext(ThemeContext);
}
function resolveMode(mode) {
  if (mode !== "system") return mode;
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function readStored(storageKey, defaultMode) {
  if (typeof window === "undefined") return defaultMode;
  const raw = window.localStorage.getItem(storageKey);
  if (raw === "light" || raw === "dark" || raw === "system") return raw;
  return defaultMode;
}
function ThemeProvider({
  children,
  storageKey = "authe-theme",
  defaultMode = "system",
  defaultBrand = {}
}) {
  const [mode, setModeState] = React.useState(() => readStored(storageKey, defaultMode));
  const [brand, setBrand] = React.useState(defaultBrand);
  const resolvedMode = resolveMode(mode);
  React.useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    root.classList.toggle("dark", resolvedMode === "dark");
  }, [resolvedMode]);
  React.useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (brand.brand) root.style.setProperty("--brand", brand.brand);
    if (brand.brandForeground) root.style.setProperty("--brand-foreground", brand.brandForeground);
    if (brand.fontSans) root.style.setProperty("--font-sans", brand.fontSans);
  }, [brand]);
  const setMode = React.useCallback(
    (next) => {
      setModeState(next);
      if (typeof window !== "undefined") {
        window.localStorage.setItem(storageKey, next);
      }
    },
    [storageKey]
  );
  const value = React.useMemo(
    () => ({ mode, setMode, resolvedMode, brand, setBrand }),
    [mode, setMode, resolvedMode, brand]
  );
  return /* @__PURE__ */ jsx(ThemeContext.Provider, { value, children });
}

export { ThemeProvider, useOptionalTheme, useTheme };
//# sourceMappingURL=chunk-EOFYHHEG.js.map
//# sourceMappingURL=chunk-EOFYHHEG.js.map